import React from "react";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";

const BancadaParlamentares = () => {
  return (
    <div>
      <h1>BancadaParlamentares</h1>
    </div>
  );
};

export default BancadaParlamentares;
